export class NavigationModel {
    public model: any[];

    constructor() {
        this.model = [
            {
                'id': 'applications',
                'title': 'Sayfalar',
                'type': 'group',
                'children': [
                    {
                        'id': 'dashboard',
                        'title': 'Kontrol Paneli',
                        'type': 'item',
                        'icon': 'dashboard',
                        'url': '/dashboard',
                        'roles': ['role1', 'role2']
                    },
                    {
                        'id': 'categorylist',
                        'title': 'Kategoriler',
                        'type': 'item',
                        'icon': 'subject',
                        'url': '/categorylist',
                        'roles': ['role1', 'role2']
                    },
                    {
                        'id': 'brandlist',
                        'title': 'Markalar',
                        'type': 'item',
                        'icon': 'stars',
                        'url': '/brandlist',
                        'roles': ['role1', 'role2']
                    },
                    {
                        'id': 'productlist',
                        'title': 'Ürünler',
                        'type': 'item',
                        'icon': 'shopping_basket',
                        'url': '/productlist',
                        'roles': ['role1', 'role2']
                    },
                    {
                        'id': 'users',
                        'title': 'Kullanıcılar',
                        'type': 'item',
                        'icon': 'people',
                        'url': '/users',
                        'roles': ['role1', 'role2']
                    },
                    {
                        'id': 'inbox',
                        'title': 'Inbox',
                        'type': 'collapse',
                        'icon': 'note',
                        'children': [
                            {
                                'id': 'contact-infos',
                                'title': 'Kullanıcı Mesajları',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/contact-infos'
                            },

                            {
                                'id': 'suggestions',
                                'title': 'Marka & Ürün Önerileri',
                                'type': 'item',
                                'icon': 'input',
                                'url': '/suggestions'
                            }, {
                                'id': 'corporate-leads',
                                'title': 'Kurumsal Başvuru Talebi',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/corporate-leads'
                            },
                            {
                                'id': 'corporate-support',
                                'title': 'Kurumsal Destek Talebi',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/corporate-support'
                            }
                        ],
                        'roles': ['role1', 'role2']

                    },
                    {
                        'id': 'complaints',
                        'title': 'İçerik Yönetimi',
                        'type': 'collapse',
                        'icon': 'note',
                        'children': [{

                            'id': 'complaints',
                            'title': 'Şikayet Bildirimleri',
                            'type': 'collapse',
                            'icon': 'note',
                            'children': [
                                {
                                    'id': 'posts',
                                    'title': 'Paylaşımlar',
                                    'type': 'item',
                                    'url': '/complaints'
                                },
                                {
                                    'id': 'users',
                                    'title': "Kullanıcılar" + ' ',
                                    'type': 'item',
                                    'url': '/user-complaints'
                                }
                            ],
                            'roles': ['role1', 'role2']
                        },
                        {
                            'id': 'compaintmanagement',
                            'title': 'İçerik Sansürleme',
                            'type': 'collapse',
                            'icon': 'lock',
                            'children': [
                                {
                                    'id': 'addtoblacklist',
                                    'title': 'Metin sansürleme',
                                    'type': 'item',
                                    'url': '/addtoblacklist'
                                },
                                {
                                    'id': 'addtoblackphoto',
                                    'title': 'Görsel sansürleme',
                                    'type': 'item',
                                    'url': '/addtoblackphoto'
                                }
                            ],
                            'roles': ['role1', 'role2']

                        },
                        {
                            'id': 'hashtagslist',
                            'title': 'Sponsorlu Hashtagler',
                            'type': 'item',
                            'icon': 'add',
                            'url': '/hashtagslist',
                            'roles': ['role1', 'role2']
                        },
                        {
                            'id': 'addtokeyword',
                            'title': 'Add to Keywords',
                            'type': 'item',
                            'icon': 'add',
                            'url': '/addtokeywords',
                            'roles': ['role1', 'role2']
                        },
                        {
                            'id': 'addtosubkeyword',
                            'title': 'Add to Subkeyword',
                            'type': 'item',
                            'icon': 'add',
                            'url': '/addtosubkeyword',
                            'roles': ['role1', 'role2']
                        },
                        ],



                    },
                    {
                        'id': 'complaints',
                        'title': 'Blog',
                        'type': 'collapse',
                        'icon': 'note',
                        'children': [

                            {
                                'id': 'blog',
                                'title': 'Blog İçerik Ekle',
                                'type': 'item',
                                'icon': 'add',
                                'url': '/blog',
                                'roles': ['role1', 'role2']
                            },
                            {
                                'id': 'blog-category',
                                'title': 'Blog Kategori Ekle',
                                'type': 'item',
                                'icon': 'add',
                                'url': '/blog-category',
                                'roles': ['role1', 'role2']
                            },
                            {
                                'id': 'blog-list',
                                'title': 'Blog İçerikleri',
                                'type': 'item',
                                'icon': 'add',
                                'url': '/blog-list',
                                'roles': ['role1', 'role2']
                            },
                            {
                                'id': 'blog-categorylist',
                                'title': 'Blog Kategori',
                                'type': 'item',
                                'icon': 'add',
                                'url': '/blog-categorylist',
                                'roles': ['role1', 'role2']
                            },


                        ],



                    },


                    {
                        'id': 'analytics',
                        'title': "bigadvice' Analytics ",
                        'type': 'collapse',
                        'icon': 'note',
                        'children': [
                            {
                                'id': 'create-corporate-user',
                                'title': 'Kurumsal Kullanıcı Tanımlama',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/create-corporate-user',
                                'roles': ['role1', 'role2']
                            },
                            {
                                'id': 'ranking',
                                'title': 'Genel Sıralama Listesi',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/ranking',
                                'roles': ['role1', 'role2']
                            },
                            {
                                'id': 'sector-ranking',
                                'title': 'Sektör Sıralama Listesi',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/sector-ranking',
                                'roles': ['role1', 'role2']
                            }, {
                                'id': 'keyword-list',
                                'title': 'Keyword List',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/keyword-list',
                                'roles': ['role1', 'role2']
                            },

                        ],
                        'roles': ['role1', 'role2']

                    },
                    {
                        'id': 'yetkilendirme',
                        'title': "Yönetici Ayarları & Yetkilendirme",
                        'type': 'collapse',
                        'icon': 'note',
                        'children': [
                            {
                                'id': 'createAdmin',
                                'title': 'Admin Kullanıcı Tanımlama',
                                'type': 'item',
                                'icon': 'account_box',
                                'url': '/create-admin',
                                'roles': ['role1', 'role2']
                            },
                            {
                                'id': 'send-message',
                                'title': 'Telerobot',
                                'type': 'item',
                                'icon': 'settings_phone',
                                'url': '/send-message',
                                'roles': ['role1', 'role2']
                            },

                        ],
                        'roles': ['role1', 'role2']

                    },




                    // {
                    //     'id': 'addtoblacklist',
                    //     'title': 'Sansürlü Kelime Ekle',
                    //     'type': 'item',
                    //     'icon': 'lock',
                    //     'url': '/addtoblacklist'
                    // },
                    // {
                    //     'id': 'contact-infos',
                    //     'title': 'Kullanıcıdan Gelen Mesajlar',
                    //     'type': 'item',
                    //     'icon': 'settings_phone',
                    //     'url': '/contact-infos',
                    //     'roles':['role1']
                    // },


                ],
                'roles': ['role1', 'role2']

            }
        ];
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/navigation.model.ts